// 2026-07-09 - FormuLearning - cross-step 값 전파 표준 pull 헬퍼 (이슈 #33 6단계)
// 파일 위치: frontend/src/lib/pullDefault.ts
// 설계 근거: 설계_260709 §3 영역C(값 전파). 도착 스텝의 파생 필드를 출처 값으로
// default-fill할지 판정하는 로직을 1곳에 모은다. Step3 total_weight_mg가 첫 표준 사례.

// 파생 필드 출처추적 규약 (설계 C-2·D-1).
// 도착 스텝 데이터는 파생 필드 {field}에 대해 다음 동반 필드를 가진다:
//   {field}_manual: boolean       — 사용자 직접 수정 여부. true면 pull이 덮지 않음(REQ-C3 수동 우선).
//   {field}_source?: string       — 출처 식별(예: 'step1.rld.weight_mg'). [P2~P4 도착 스텝 실구현 시 백엔드 컬럼 도입]
//   {field}_computed_at?: string  — 파생 계산 시각(ISO). stale 판정 기준.        [P2~P4 실구현 시 도입]
// 현재 이슈에서는 _manual만 실컬럼(Step3), _source/_computed_at은 규약 정의만 두고
// 각 도착 스텝(Step5 factors·Step6 PK) 실구현 PR에서 컬럼과 stale 배너를 도입한다.
export interface DerivedFieldMeta {
  manual: boolean
  source?: string
  computed_at?: string
}

export interface PullOptions<T> {
  current: T | null // 도착 스텝의 현재 파생값
  sourceValue: T | null // 출처 스텝에서 조회한 값
  isManual: boolean // {field}_manual — true면 pull 미적용
  isValid?: (v: T) => boolean // 출처값 유효성(기본: null 아님)
  isEqual?: (a: T, b: T) => boolean // 변경 감지(기본: ===). 같으면 불필요한 재기록 방지
}

// 표준 pull 판정 — 채워야 하면 sourceValue, 아니면 null 반환.
// 규칙: 수동 편집(isManual) → 미적용 / 출처값 무효 → 미적용 / 현재값과 동일 → 미적용.
export function pullDefault<T>(o: PullOptions<T>): T | null {
  if (o.isManual) return null
  if (o.sourceValue == null) return null
  if (o.isValid && !o.isValid(o.sourceValue)) return null
  if (o.current != null) {
    const same = o.isEqual ? o.isEqual(o.current, o.sourceValue) : o.current === o.sourceValue
    if (same) return null
  }
  return o.sourceValue
}

// 숫자 파생 필드용 공통 술어.
export const positiveNumber = (v: number): boolean => Number.isFinite(v) && v > 0
export const numericEquals = (epsilon: number) => (a: number, b: number): boolean => Math.abs(a - b) < epsilon
